import Enum from './enum'

class SpecificationTemplateField extends Enum
{
  constructor(value) {
    super(value);
  }
}

SpecificationTemplateField.init({
  NONE: 'none',
  NOMENCLATURE: 'nomenclature',
  COUNT: 'count',
  OKEI: 'okei',
  PRICE: 'price',
  CURRENCY_BID: 'currencyBid',
  CURRENCY_PAY: 'currencyPay',
  PART: 'part',
  POSITION: 'position'
}, {
  NONE: 'specification-template-field.none',
  NOMENCLATURE: 'specification-template-field.nomenclature',
  COUNT: 'specification-template-field.count',
  OKEI: 'specification-template-field.okei',
  PRICE: 'specification-template-field.price',
  CURRENCY_BID: 'specification-template-field.currency-bid',
  CURRENCY_PAY: 'specification-template-field.currency-pay',
  PART: 'specification-template-field.part',
  POSITION: 'specification-template-field.serial'
});

export default SpecificationTemplateField;
